export default __webpack_public_path__ + "static/media/bloom-plume-01.817b3dd3.png";